var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-btn',{staticClass:"rounded-0 mt-0",attrs:{"variant":"light","block":"","size":_vm.$screen.lg ? 'lg' : 'sm'},on:{"click":_vm.createRequest}},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"fa-duotone fa-hand-holding-dollar","size":"lg"}})],1),_vm._v(" "+_vm._s(_vm.$t("Request"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }